export var LocationType;
(function (LocationType) {
    LocationType["GPS"] = "GPS";
    LocationType["Mesh"] = "MESH";
    LocationType["Proximity"] = "PROXIMITY";
    LocationType["Fixed"] = "FIXED";
    LocationType["Cellular"] = "CELLULAR";
    LocationType["WiFi"] = "WIFI";
    LocationType["Internal"] = "INTERNAL";
})(LocationType || (LocationType = {}));
//# sourceMappingURL=location.js.map